var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "flex h-screen"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.submitted,
      expression: "submitted"
    }]
  }, [_c('img', {
    staticClass: "w-full max-w-md px-2 mb-4",
    attrs: {
      "src": "https://images.typeform.com/images/J3TAXxwY6jjY/image/default"
    },
    on: {
      "click": _vm.tap
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("You're a great friend.")]), _vm._v(" "), _c('p', {
    staticClass: "my-4 text-xl leading-8 text-center"
  }, [_vm._v("\n\t\t\t\t\t\tThank you for the referral, we'll take it from here.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.submitted && !_vm.userId,
      expression: "!submitted && !userId"
    }]
  }, [_c('p', {
    staticClass: "my-8 text-xl leading-8 text-center"
  }, [_vm._v("\n\t\t\t\t\t\tOpen this page from your Extra App to continue\n\t\t\t\t\t")])])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };